export const motion = {
  durationEnter: '200ms',
  durationExit: '140ms',
  easing: 'cubic-bezier(0.22, 1, 0.36, 1)',
  translateY: '8px',
} as const;
